module.exports = __webpack_public_path__ + "en_US.json";


// WEBPACK FOOTER //
// ./src/en_US.json